import { withOidcSecure } from '@axa-fr/react-oidc';
import { createBrowserRouter, createRoutesFromElements, Navigate, Route, useParams } from 'react-router';

import { CompleteDoka360RegistrationView } from 'app/request/CompleteDoka360RegistrationView';
import { Doka360AvailableView } from 'app/request/Doka360AvailableView';
import { ManageRequests } from 'app/request/ManageRequests';
import { OnboardingFrame as RequestFrame } from 'app/request/OnboardingFrame';
import { SelectCustomerView } from 'app/request/SelectCustomerView';
import { Home } from './Home';
import { NotFound } from './NotFound';
import { Request } from './request/Request';
import { RequestExpired } from './request/RequestExpired';
import { RequestNotFoundExpired } from './request/RequestNotFound';
import { Invitation } from './start/Invitation';
import { StartLayoutFrame } from './start/StartLayoutFrame';
import { Unauthorized } from './Unauthorized';

const SecureRequestFrame = withOidcSecure(RequestFrame);
const SecureStartLayoutFrame = withOidcSecure(StartLayoutFrame);

const NavigateToRequests = withOidcSecure(() => {
    const { requestId = '' } = useParams();
    return <Navigate to={`/requests/${requestId}`} replace />;
});

const AppRoutes = () => {
    return (
        <>
            <Route Component={SecureStartLayoutFrame}>
                <Route Component={SelectCustomerView} path="/requests/create" />
                <Route Component={ManageRequests} path="requests" />
                <Route Component={Invitation} path="invitation/:requestId" />
                <Route Component={RequestNotFoundExpired} path="requests/not-found-expired" />
                <Route Component={RequestExpired} path="requests/expired" />
                <Route Component={Doka360AvailableView} path="requests/doka360/available" />
                <Route Component={CompleteDoka360RegistrationView} path="requests/doka360/existing" />
            </Route>
            <Route Component={SecureRequestFrame} path="/">
                <Route Component={Home} path="" />
                <Route Component={NavigateToRequests} path="request/:requestId" />
                <Route Component={Request} path="requests/:requestId" />
            </Route>
            <Route Component={Unauthorized} path="/unauthorized" />
            <Route Component={NotFound} path="*" />
        </>
    );
};
export const router = createBrowserRouter(createRoutesFromElements(AppRoutes()));
